import { DateTime } from 'luxon';
import { Badge, ProgressBar } from 'react-bootstrap';
import { ColorSetting, OrdersWootTableRow } from '../../WootOrdersImport.interfaces';
import { getSalesforceUrlByWindowLocation } from '../../../common/common.entities';

interface WootFbaJourneyHeaderProps {
  row: OrdersWootTableRow
  poColors: ColorSetting
  allocationColors: ColorSetting
  returnColors: ColorSetting
  invoiceColors: ColorSetting
  completePercent: number
  pendingPercent: number
  errorPercent: number
  notStartedPercent: number
}

export default function WootFbaJourneyHeader(props: WootFbaJourneyHeaderProps) {
  const {allocationColors, completePercent, errorPercent, invoiceColors, pendingPercent, notStartedPercent, poColors, returnColors, row } = props
  return <div>
        <div style={{display: 'flex', gap: '15px'}}>
          <div style={{width: '200px'}}>
            <span className='beacon-label'> created {DateTime.fromISO(row.createdTimestamp).toLocaleString(DateTime.DATETIME_SHORT)}</span>
            <br/>
            <span className='beacon-label'> updated {DateTime.fromISO(row.timestamp).toLocaleString(DateTime.DATETIME_SHORT)}</span>
          </div>
          <div style={{width: '200px'}}>
            <span className='beacon-header'>
               ALLOCATION PO
            </span>
            <span style={{float: 'right'}}><Badge bg={allocationColors.bg} text={allocationColors.fg}>{row.allocationStatus?.toUpperCase()}</Badge></span>
            <br/>
            {row.allocationStatus === 'pending' ? 
              <span className='beacon-label'>Pending Mapping & Mission Control</span> : 
                row.allocationStatus === 'error' ? 
                  <span className='beacon-label'>Mapping Issues Require Manual Input</span> : 
                    row.allocationStatus === 'complete' ? 
                      row.allocationIags && <div>
                        {JSON.parse(row.allocationIags).map((iag, index) => (
                          <>
                            <span className='beacon-label'>
                              <a target="_blank" rel="noopener noreferrer" href={`${getSalesforceUrlByWindowLocation(window.location.href)}/${iag.Id}`}>IAG {index+1}</a>&nbsp;&nbsp;
                            </span>
                          </>
                        ))}
                      </div>
                      : <span className='beacon-label'>Unknown Status</span>

            }
            <br/>
            <span className='beacon-label'>{
              row.allocationTimestamp ? <>allocated {DateTime.fromISO(row.allocationTimestamp).toLocaleString(DateTime.DATETIME_SHORT)}</> : <></>
            }</span>
          </div>
          <div style={{width: '200px'}}>
            <span className='beacon-header'>
               RETURN PO
            </span>
            <span style={{float: 'right'}}><Badge bg={returnColors.bg} text={returnColors.fg}>{row.returnStatus?.toUpperCase() ?? 'NOT STARTED'}</Badge></span>
            <br/>
            {row.returnStatus === 'pending' ? 
              <span className='beacon-label'>Pending Mapping & Mission Control</span> : 
                row.returnStatus === 'error' ? 
                  <span className='beacon-label'>Mapping Issues Require Manual Input</span> : 
                    row.returnStatus === 'complete' ? 
                      <div className='beacon-label'>
                      <a target="_blank" rel="noopener noreferrer" href={`${getSalesforceUrlByWindowLocation(window.location.href)}/${JSON.parse(row.returnOrder).Id}`}>ORDER</a>&nbsp;&nbsp;
                      {JSON.parse(row.returnIags).map((iag, index) => (
                        <>
                          <span>
                            <a target="_blank" rel="noopener noreferrer" href={`${getSalesforceUrlByWindowLocation(window.location.href)}/${iag.Id}`}>IAG {index+1}</a>&nbsp;&nbsp;
                          </span>
                        </>
                      ))}
                    </div>
                    : <span className='beacon-label'>Unknown Status</span>

            }
            <br/>
            <span className='beacon-label'>{
              row.returnTimestamp ? <>returned {DateTime.fromISO(row.returnTimestamp).toLocaleString(DateTime.DATETIME_SHORT)}</> : <></>
            }</span>
          </div>
          <div style={{width: '200px'}}>
            <span className='beacon-header'>
               INVOICE REQUEST
            </span>
            <span style={{float: 'right'}}><Badge bg={invoiceColors.bg} text={invoiceColors.fg}>{row.invoiceStatus?.toUpperCase() ?? 'NOT STARTED'}</Badge></span>
            <br/>
            {row.invoiceStatus === 'pending' ? 
              <span className='beacon-label'>Pending Mapping & Mission Control</span> : 
                row.invoiceStatus === 'error' ? 
                  <span className='beacon-label'>Mapping Issues Require Manual Input</span> : 
                    row.invoiceStatus === 'complete' ? 
                      <span className='beacon-label'></span> : <span className='beacon-label'>Not Started</span>

            }
            <br/>
            <span className='beacon-label'>{
              row.returnTimestamp ? <>invoiced {DateTime.fromISO(row.returnTimestamp).toLocaleString(DateTime.DATETIME_SHORT)}</> : <></>
            }</span>
          </div>
        </div>
        <ProgressBar>
          <ProgressBar striped variant="success" now={completePercent} key={1}/>
          <ProgressBar animated variant="warning" now={pendingPercent} key={2}/>
          <ProgressBar striped variant="danger" now={errorPercent} key={3}/>
          <ProgressBar animated variant="secondary" now={notStartedPercent} key={4} />
        </ProgressBar>
  </div>
}